(function () {
  var root = document.getElementById('XrSignup');
  if (!root || root.__xrInit || root.dataset.pageType !== 'index') return;
  root.__xrInit = true;

  var KEY = 'xr-signup', SENT = 'xr-signup-sent', SEEN = 'xr-signup-seen', EDITOR = 'xr-signup-editor-closed';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null, timer = null, exitTimer = null, closedAt = 0;

  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
  function del(store, k) { try { window[store].removeItem(k); } catch (e) {} }

  function seenThisSession() {
    try {
      if (document.cookie.split(';').some(function (cookie) { return cookie.trim() === SEEN + '=1'; })) return true;
    } catch (e) {}
    return get('sessionStorage', SEEN);
  }

  function stopTriggers() {
    clearTimeout(timer);
    clearTimeout(exitTimer);
    document.removeEventListener('mouseout', onExit);
  }

  function focusables() {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button, input:not([type="hidden"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function open() {
    if (!root.hidden) return;
    stopTriggers();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('signup-locked');
    requestAnimationFrame(function () { root.classList.add('signup--open'); });
    var first = root.querySelector('input[type="email"]') || root.querySelector('.signup__close');
    setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, reduce ? 0 : 200);
  }

  function close() {
    stopTriggers();
    if (root.hidden) return;
    if (root.hasAttribute('data-editor-open')) set('sessionStorage', EDITOR, '1');
    root.classList.remove('signup--open');
    document.body.classList.remove('signup-locked');
    setTimeout(function () { root.hidden = true; }, reduce ? 0 : 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) open(); }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-signup-close]')) { e.preventDefault(); closedAt = Date.now(); close(); return; }
    var copy = e.target.closest('[data-signup-copy]');
    if (copy) {
      var code = copy.getAttribute('data-signup-copy');
      var done = function () { copy.textContent = copy.getAttribute('data-copied') || 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  // The editor also selects the section when its backdrop is clicked; don't reopen on that.
  document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') === e.target && Date.now() - closedAt > 800) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('.shopify-section') === e.target) close(); });

  window.addEventListener('pagehide', function () {
    stopTriggers();
    root.hidden = true;
    root.classList.remove('signup--open');
    document.body.classList.remove('signup-locked');
  });

  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { set('sessionStorage', SENT, '1'); });

  if (get('sessionStorage', SENT)) {
    if (root.querySelector('[data-signup-done]')) {
      del('sessionStorage', SENT);
      set('localStorage', KEY, 'joined');
      open();
      return;
    }
    if (root.querySelector('[data-signup-error]')) { del('sessionStorage', SENT); open(); return; }
  }

  if (root.hasAttribute('data-editor-open')) { if (!get('sessionStorage', EDITOR)) open(); return; }
  if (window.XRED && window.XRED.designMode) return;
  if (get('localStorage', KEY) === 'joined' || seenThisSession()) return;
  set('sessionStorage', SEEN, '1');
  try { document.cookie = SEEN + '=1; Path=/; SameSite=Lax'; } catch (e) {}

  timer = setTimeout(open, (+root.dataset.delay || 0) * 1000);
  if (root.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) {
    exitTimer = setTimeout(function () { document.addEventListener('mouseout', onExit); }, 3000);
  }

})();
